/* eslint-disable complexity */
// avoiding package root import to avoid circular dependency
// eslint-disable-next-line monorepo/no-internal-import
import {Locale} from '@aboutyou/config/src/locale';
// eslint-disable-next-line monorepo/no-internal-import
import {assertUnreachable} from '@aboutyou/utils/src/assertUnreachable';

export interface TopCategorySlugs {
  female: string;
  male: string;
  children: string;
}

export function getTopCategorySlugsByLocale_UNSAFE(
  locale: Locale,
): TopCategorySlugs {
  switch (locale) {
    case Locale.de_AT:
    case Locale.de_CH:
    case Locale.de_DE:
      return {
        female: 'frauen',
        male: 'maenner',
        children: 'kinder',
      };

    case Locale.fr_CH:
    case Locale.fr_BE:
    case Locale.fr_LU:
    case Locale.fr_FR:
      return {
        female: 'femme',
        male: 'homme',
        children: 'enfants',
      };

    case Locale.nl_NL:
    case Locale.nl_BE:
      return {
        female: 'dames',
        male: 'heren',
        children: 'kinderen',
      };

    case Locale.pl_PL:
      return {
        male: 'mezczyzni',
        female: 'kobiety',
        children: 'dzieci',
      };

    case Locale.cs_CZ:
      return {
        female: 'zeny',
        male: 'muzi',
        children: 'deti',
      };

    case Locale.ro_RO:
      return {
        female: 'femei',
        male: 'barbati',
        children: 'copii',
      };

    case Locale.hu_HU:
      return {
        female: 'noi',
        male: 'ferfi',
        children: 'gyerek',
      };

    case Locale.sk_SK:
      return {
        female: 'zeny',
        male: 'muzi',
        children: 'deti',
      };

    case Locale.sl_SI:
      return {
        female: 'zenske',
        male: 'moski',
        children: 'otroci',
      };

    case Locale.lv_LV:
      return {
        female: 'sievietem',
        male: 'viriesiem',
        children: 'berniem',
      };

    case Locale.lt_LT:
      return {
        female: 'moterims',
        male: 'vyrams',
        children: 'vaikams',
      };

    case Locale.et_EE:
      return {
        female: 'naised',
        male: 'mehed',
        children: 'lapsed',
      };

    case Locale.hr_HR:
      return {
        female: 'zene',
        male: 'muskarci',
        children: 'djeca',
      };

    case Locale.bg_BG:
      return {
        female: 'zheni',
        male: 'mazhe',
        children: 'detsa',
      };
    case Locale.sv_SE:
      return {
        female: 'kvinnor',
        male: 'maen',
        children: 'barn',
      };
    case Locale.da_DK:
      return {
        female: 'kvinder',
        male: 'maend',
        children: 'boern',
      };
    case Locale.fi_FI:
      return {
        female: 'naiset',
        male: 'miehet',
        children: 'lapset',
      };
    case Locale.en_ZZ:
    case Locale.en_DE:
    case Locale.en_IE:
    case Locale.en_SA:
    case Locale.en_IL:
      return {
        female: 'women',
        male: 'men',
        children: 'kids',
      };
    case Locale.es_ZZ:
    case Locale.es_ES:
      return {
        female: 'mujer',
        male: 'hombre',
        children: 'infantil',
      };
    case Locale.it_IT:
    case Locale.it_CH:
      return {
        female: 'donna',
        male: 'uomo',
        children: 'bambini',
      };
    case Locale.pt_PT:
      return {
        female: 'mulher',
        male: 'homem',
        children: 'crianca',
      };
    case Locale.el_CY:
    case Locale.el_GR:
      return {
        female: 'ginaikes',
        male: 'andres',
        children: 'paidia',
      };
    case Locale.no_NO:
      return {
        female: 'dame',
        male: 'herre',
        children: 'barn',
      };
    case Locale.he_IL:
      return {
        female: 'nshym',
        male: 'gbrym',
        children: 'yldym',
      };
    case Locale.ar_SA:
      return {
        female: 'sydat',
        male: 'rgal',
        children: 'atfal',
      };
    case Locale.ru_EE:
    case Locale.ru_LV:
      return {
        female: 'zenshhiny',
        male: 'muzciny',
        children: 'deti',
      };
    default:
      assertUnreachable(locale);
  }
}
